import { Section } from '@/components/layout';
import { DisplayTitle, Eyebrow, Lead } from '@/components/typography';
import { Reveal } from '@/components/motion';
import { MEXICO_COPY } from '../copy';
import { SunBurst } from '../ornaments/SunBurst';
import { GoldWave } from '../ornaments/GoldWave';
import styles from './ManifiestoMexico.module.css';

const TITLE_ID = 'mexico-manifiesto';

/**
 * S2 · MANIFIESTO "EL ANCLAJE MAYOR" — banda y 660-870 del mockup.
 * Crema liso, todo centrado, y la ondulación dorada haciendo de bisagra con
 * los tres pilares. No hay cambio de color entre S2 y S3: los separa la onda.
 */
export function ManifiestoMexico() {
  const { manifiesto } = MEXICO_COPY;

  return (
    <>
      <Section
        background="surface"
        spacing="tight"
        width="narrow"
        labelledBy={TITLE_ID}
        className={styles.section}
      >
        <Reveal className={styles.block}>
          <p className={styles.mark}>
            <span className={styles.rule} />
            {/* 36 y no 28: el sol del póster mide 39x25 px de tinta (medido con
                proyección) y con `size={28}` el nuestro daba 12 de alto. */}
            <SunBurst size={36} />
            <span className={styles.rule} />
          </p>

          <Eyebrow ink="gold" align="center" className={styles.eyebrow}>
            {manifiesto.eyebrow}
          </Eyebrow>

          <DisplayTitle id={TITLE_ID} level={2} size="sm" align="center" className={styles.title}>
            {manifiesto.titleLines.map((line) => (
              <span key={line} className={styles.titleLine}>
                {line}
              </span>
            ))}
          </DisplayTitle>

          <Lead align="center" className={styles.lead}>
            {manifiesto.lead}
          </Lead>
        </Reveal>
      </Section>

      <GoldWave className={styles.wave} />
    </>
  );
}
